import Vue from "vue";
import Router from "vue-router";
import { ROUTER_MODE } from "../config/app";

import Home from "../views/home/index.vue";

// 静态路由
import err401 from "../views/error/err401.vue";
import err404 from "../views/error/err404.vue";
import err500 from "../views/error/err404.vue";
import login from "../views/login/index.vue";
// 前言
import main from "../views/home/main.vue";
import mainData from "../views/home/data.vue"

// 公共模块测试
import uploadList from "../views/components/uploadList.vue";

// 管理组相关
import adminRouter from "../views/userManage/admin/router.vue";
import authAdmin from "../views/userManage/admin/authAdmin.vue";
import authRole from "../views/userManage/admin/authRole.vue";
import authPermissionRule from "../views/userManage/admin/authPermissionRule.vue";

// 广告管理
import adSite from "../views/adManage/adSite.vue";
import ad from "../views/adManage/ad.vue";

// 用户管理
import customer from "../views/customer/index.vue"
import customerDetails from "../views/customer/details.vue"
import customerEquipmentDetails from "../views/customer/equipment-details.vue"

// 维保信息管理
import maintain from "../views/maintain/index.vue"
import maintainDetails from "../views/maintain/details.vue"

// 巡查团队管理
import patrol from "../views/patrol/index.vue"
import patrolDetails from "../views/patrol/details.vue"

// 销售人员管理
import sale from "../views/sale/index.vue"
import saleDetails from "../views/sale/details.vue"

// 其他管理
import maintenanceReason from "../views/other/maintenanceReason.vue"

// 列表管理
import equipmentList from "../views/allList/equipmentList.vue"
import projectList from "../views/allList/projectList.vue"
import newTaskList  from "../views/allList/newTaskList .vue"
import maintenanceTaskList from "../views/allList/maintenanceTaskList.vue"
import patrolTaskList from "../views/allList/patrolTaskList.vue"

Vue.use(Router);

// 注意 权限字段 authRule （严格区分大小写）
export const constantRouterMap = [
    {
        path: "*",
        component: err404,
        hidden: true
    },
    {
        path: "/401",
        component: err401,
        name: "401",
        hidden: true
    },
    {
        path: "/404",
        component: err404,
        name: "404",
        hidden: true
    },
    {
        path: "/500",
        component: err500,
        name: "500",
        hidden: true
    },
    {
        path: "/login",
        component: login,
        name: "登录",
        hidden: true
    },
    {
        path: "/",
        component: Home,
        redirect: "/readme",
        name: "首页",
        hidden: true
    },
    {
        path: "/readme",
        component: Home,
        redirect: "/readme/main",
        icon: "tongyong",
        name: "数据管理",
        // noDropdown: true,
        // children: [
        //     {
        //         path: "main",
        //         component: main
        //     }
        // ]
        children: [
            {
                path: "main",
                name: '大屏展示',
                component: main,
                icon: "0",
                meta: {
                    authRule: ["/readme/main"]
                }
            },
            {
                path: "data",
                name: '大屏数据管理',
                component: mainData,
                icon: "0",
                meta: {
                    authRule: ["/readme/data"]
                }
            },
            {
                path: "maintenanceReason",
                name: '维修原因管理',
                component: maintenanceReason,
                icon: "0",
                meta: {
                    authRule: ["/other/maintenanceReason"]
                }
            }
        ]
    },
    // {
    //     path: "/components",
    //     redirect: "/components/uploadList",
    //     component: Home,
    //     name: "实例",
    //     icon: "tongyong",
    //     children: [
    //         {
    //             path: "uploadList",
    //             name: "上传图片的展示",
    //             component: uploadList
    //         }
    //     ]
    // }
];

export default new Router({
    // mode: 'history', //后端支持可开
    mode: ROUTER_MODE,
    routes: constantRouterMap,
    strict: process.env.NODE_ENV !== "production"
});

export const asyncRouterMap = [
    {
        path: '/customer',
        component: Home,
        redirect: "/customer/index",
        icon: 'jiaose',
        name: '人员管理',
        children: [
            {
                path: 'index',
                name: '客户管理',
                icon: "0",
                component: customer,
                // meta: {
                //     authRule: ["/customer/index"]
                // }
            },
            {
                path: "details",
                name: "客户详情",
                icon: "0",
                component: customerDetails,
                // meta: {
                //     authRule: ["/customer/details"]
                // },
                hidden: true
            },
            {
                path: "equipment-details",
                name: "客户设备详情",
                icon: "0",
                component: customerEquipmentDetails,
                // meta: {
                //     authRule: ["/customer/equipment-details"]
                // },
                hidden: true
            },
            {
                path: 'maintain/index',
                name: '维保团队管理',
                icon: "0",
                component: maintain,
            },
            {
                path: "/maintain/details",
                name: "维保详情",
                icon: "0",
                component: maintainDetails,
                hidden: true
            },
            {
                path: 'patrol/index',
                name: '巡查团队管理',
                icon: "0",
                component: patrol,
            },
            {
                path: "patrol/details",
                name: "巡查团队详情",
                icon: "0",
                component: patrolDetails,
                hidden: true
            },
            {
                path: 'sale/index',
                name: '销售人员管理',
                icon: "0",
                component: sale,
            },
            {
                path: "sale/details",
                name: "销售人员管理详情",
                icon: "0",
                component: saleDetails,
                hidden: true
            },
        ]
    },
    {
        path: "/allList",
        redirect: "/allList/equipmentList",
        component: Home,
        icon: "wxbzhanghu",
        name: "列表管理",
        children: [
            {
                path: "equipmentList",
                component: equipmentList,
                name: "设备列表",
                icon: "0",
            },
            {
                path: "projectList",
                component: projectList,
                name: "项目列表",
                icon: "0",
            },
            {
                path: "newTaskList ",
                component: newTaskList ,
                name: "新装任务列表",
                icon: "0",
            },
            {
                path: "maintenanceTaskList",
                component: maintenanceTaskList,
                name: "维保任务列表",
                icon: "0",
            },
            {
                path: "patrolTaskList",
                component: patrolTaskList,
                name: "巡查任务列表",
                icon: "0",
            }
        ]
    },
    {
        path: "/userManage",
        redirect: "/userManage/adminManage/index",
        component: Home,
        icon: "guanliyuan1",
        name: "系统管理",
        meta: {
            authRule: ["user_manage"]
        },
        // noDropdown: true,
        children: [
            {
                path: "authAdmin",
                component: authAdmin,
                name: "管理员管理",
                icon: "0",
                meta: {
                    authRule: ["admin/auth_admin/index"]
                }
            },
            // {
            //     path: "authRole",
            //     component: authRole,
            //     name: "角色管理",
            //     icon: "0",
            //     meta: {
            //         authRule: ["admin/auth_role/index"]
            //     }
            // },
            // {
            //     path: "authPermissionRule",
            //     component: authPermissionRule,
            //     name: "权限管理",
            //     icon: "0",
            //     meta: {
            //         authRule: ["admin/auth_permission_rule/index"]
            //     }
            // }
        ]
    },
];
